import logoUrl from "@/assets/site/sunshell-one-logo.png";
import appShotUrl from "@/assets/site/app-screenshot.jpeg";
import partnerAppShotUrl from "@/assets/site/partner-app-screenshot.webp";
import heroImg from "@/assets/site/hero-rooftop.jpeg";
import shopkeeperImg from "@/assets/site/shopkeeper.jpg";
import indianFamilyRooftopSolarImg from "@/assets/site/indian-family-rooftop-solar.png";
import businessImg from "@/assets/site/business.jpg";
import farmImg from "@/assets/site/farm.jpg";
import testimonialImg from "@/assets/site/testimonial.jpg";

export const LOGO_URL = logoUrl;
export const APP_SHOT_URL = appShotUrl;
export const HERO_IMG = heroImg;

export const IMAGES = {
  shopkeeper: shopkeeperImg,
  home: indianFamilyRooftopSolarImg,
  business: businessImg,
  farm: farmImg,
  society: heroImg,
  testimonial: testimonialImg,
};

export const NAV_LINKS = [
  { label: "How it works", target: "how" },
  { label: "Built for India", target: "audience" },
  { label: "Apps", target: "apps-download" },
  { label: "About", target: "proof" },
];

export const APP_LINKS = {
  customer: {
    label: "SunShell One",
    audience: "For customers",
    title: "Run your solar journey from one app.",
    description: "Track your project, documents, payments, installation progress, savings and service requests in one place.",
    cta: "Download customer app",
    url: "https://play.google.com/store/apps/details?id=com.sunshellone.customer",
    screenshotUrl: appShotUrl,
    highlights: ["Project tracking", "Documents and payments", "Savings and service"],
  },
  partner: {
    label: "SunShell Partner",
    audience: "For partners",
    title: "Manage leads, surveys and installation work.",
    description: "Use the partner app to handle assigned leads, site survey images, installation checklists and customer coordination.",
    cta: "Download partner app",
    url: "https://play.google.com/store/apps/details?id=com.sunshellone.partnerapp",
    screenshotUrl: partnerAppShotUrl,
    highlights: ["Lead workflow", "Site survey capture", "Installation updates"],
  },
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    window.location.href = id === "hero" ? "/" : `/#${id}`;
    return;
  }
  const offset = id === "apps-download" ? -92 : -70;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.2, lock: true });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
};
